/* eslint-disable @typescript-eslint/no-shadow */

import React, { memo, useState } from "react";

import styled from "styled-components";

import { Checkbox, CheckboxProps } from "@origin-digital/ods-core";

export type VerticalLabeledCheckboxProps = CheckboxProps;

const CheckboxContainer = styled.div(() => ({
  "&": {
    backgroundColor: "white",
    borderRadius: "8px",
    border: "2px solid transparent",

    "&.checked": {
      borderColor: "#FFB432",
    },

    "& label": {
      alignItems: "center",
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
      height: "100%",

      "& .MuiFormControlLabel-label": {
        fontWeight: "bold",
      },
    },
  },
}));

export const VerticalLabeledCheckbox = memo(
  (props: VerticalLabeledCheckboxProps) => {
    const [checked, setChecked] = useState(false);

    const handleOnChange = (
      event: React.ChangeEvent<HTMLInputElement>,
      checked: boolean
    ) => {
      setChecked(checked);
      if (props.onChange) {
        props.onChange(event, checked);
      }
    };

    return (
      <CheckboxContainer className={checked ? "checked" : "unchecked"}>
        <Checkbox
          className="custom-checkbox"
          muiProps={{
            formControlLabelProps: { labelPlacement: "bottom" } as any,
          }}
          {...props}
          onChange={handleOnChange}
        />
      </CheckboxContainer>
    );
  }
);
